export enum UserRole { rider, driver, admin, support }
export enum RideStatus { requested, accepted, arrived, in_progress, completed, cancelled, expired }
export enum RideType { Auto, Cab, Hatchback, Sedan, SUV, Bike, Other }
export enum PaymentStatus { pending, completed, refund_requested, refunded, failed }
export enum DriverStatus {
    OFFLINE = 'OFFLINE',
    SILENT = 'SILENT',
    ONLINE = 'ONLINE',
}